import TagManager from 'react-gtm-module';

export const initializeGTM = () => {
  TagManager.initialize({
    gtmId: 'GTM-WM33RDT'
  });
};

export const trackEvent = (event: Record<string, any>) => {
  TagManager.dataLayer({
    dataLayer: {
      event: event.eventName,
      ...event.data,
    },
  });
};